import template from './academy-course-track-quiz.component.html';
import controller from './academy-course-track-quiz.controller';

const academyCourseTrackQuiz = {
  bindings: {
    courseTrack: '<',
    user: '<',
  },
  template,
  controller,
};

export default academyCourseTrackQuiz;
